import React, {memo, useState} from "react";
//local
import SubHeading from "components/SubHeading";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {EditorTemplatesModal} from "components/modals/EditorTemplatesModal";
import {showError} from "helpers/notifications.helper";
import {IconCog, IconList} from "components/icons";

const EditorTemplatesSettings = memo(({isAdminOwner}) => {
  const [isEditorTemplatesModal, setEditorTemplatesModal] = useState(false);

  return (
    <>
      <div className="organization-settings mb-12">
        <SubHeading title="SETTINGS_ORGANIZATION_EDITOR_TEMPLATES" icon={<IconList />} />
        <div className="df-row-center mt-2">
          <ButtonTransparent
            name="SETTINGS_ORGANIZATION_EDITOR_TEMPLATES_BUTTON"
            icon={<IconCog />}
            noBorder
            small
            addClass="fz-14 pl-0 __rotate-on-hover"
            onClick={() =>
              isAdminOwner
                ? setEditorTemplatesModal(true)
                : showError("WRONG_PRIVILEGES_ONLY_OWNER_ADMIN")
            }
          />
        </div>
      </div>
      {isEditorTemplatesModal && (
        <EditorTemplatesModal onClose={() => setEditorTemplatesModal(false)} />
      )}
    </>
  );
});
export default EditorTemplatesSettings;
